import { DatePipe, formatDate } from "@angular/common";
import { MatDialog } from '@angular/material/dialog';
import { Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { DynamicFormComponent } from "src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component";
import { FieldConfig } from "src/app/CommonComponents/dynamic-form/interface/field.interface";
import { CommonService } from "src/app/Service/Common.service";
import { NotificationService } from "src/app/Service/notification.service";
import { ProjectInfoService } from "src/app/Service/project-info/project-info.service";
import { ScheduleDefinitionService } from "src/app/Service/scheduledefintion/scheduledefintion.service";
import { ScheduleDocumentService } from "src/app/Service/scheduledocument/scheduleDocument.service";
import { IDCIViewModel } from "src/app/ViewModel/DCIViewModels";
import { IScheduleDocInfo, IRevisionCategory, IScheduleType, IScheduleDocApprovalDetails, IScheduleDocApprovalDocId } from "src/app/ViewModel/ScheduleDocumentModel";
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { ScheduleWorkflowhistoryComponent } from "../schedule-workflowhistory/schedule-workflowhistory.component";
import { DciSupersedeComponent } from "../dci-supersede/dci-supersede.component";
import { ProjectMasterService } from "src/app/Service/projectmaster/projectmaster.service";
import { IProjectMasterViewModel } from "src/app/ViewModel/ProjectMasterModel";
import { RowArgs } from "@progress/kendo-angular-grid";
import { FileListComponent } from "src/app/CommonComponents/file-list/file-list.component";
import { FileUploadLibrary } from "src/app/Service/file/file.service";
import { ITransmittalDetailsModel, ITransmittalDocumentDetails, ITransmittalDocumentInput, ITransmittalMsgReceiverInput } from "src/app/ViewModel/TransmittalModel";
import { TransmittalMsgService } from "src/app/Service/transmittal/transmittal.service";
import { TransmittalTemplateComponent } from "../../transmittal/transmittal-template/transmittal-template.component";
import { LoaderService } from "src/app/Service/Loader/loader.service";
import { ProjectMemberModel } from "src/app/ViewModel/ProjectMemberModel";
import { TransmittalService } from "src/app/Service/transmittal-template/transmittal-template.service";
import { ProjectViewModel } from "src/app/ViewModel/ProjectModel";
import { Subscription } from 'rxjs/internal/Subscription';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { saveAs } from 'file-saver';
import { IProjectElementsOutput } from "src/app/ViewModel/ProjectElementsModel";
import { Module } from "src/app/Service/element-details.data.service";

@Component({
    selector: 'app-schedule-view',
    templateUrl: './schedule-view.component.html',
    styles: [`   
    ::ng-deep .k-radio:checked, .k-radio.k-checked {
        border-color: #065497;
        color: white;
        background-color: #065497;
     }

     ::ng-deep .k-grid .k-hierarchy-col {
        width: 15px;
       }

    ::ng-deep .k-grid .k-grid-filter,::ng-deep .k-grid .k-header-column-menu,::ng-deep .k-grid .k-hierarchy-cell .k-icon {
        color: white !important;
     }

     ::ng-deep .k-grid-header .k-grid-filter,::ng-deep .k-grid-header .k-header-column-menu {
        padding: 0px !important;
        width: 5px !important;
        height: 15px !important;
     }
    `]
})
export class ScheduleViewComponent implements OnInit, OnDestroy {
    subscriptions: Subscription[] = []
    private _schDoc!: IScheduleDocInfo;
    private _dciViewModel!: IDCIViewModel;
    projectId!: number;
    memberId!: number;
    groupId!: number;
    isShowStartWF: boolean = false;
    isShowWFHistory: boolean = false;
    isShowEdit: boolean = false;
    isShowSuperEdit: boolean = false;
    isShowSupersede: boolean = false;
    isShowApprove: boolean = false;
    isRejected:boolean = false;
    get schDoc(): IScheduleDocInfo {
        return this._schDoc;
    }
    @Input() set schDoc(value: IScheduleDocInfo) {
        this.isRejected = value.approval_Date !== null && !value.approved_Tag;
        if (!!value && typeof value == "object") {
            this._schDoc = value;
            this.fetchDciViewDocDetails();
        }
    }

    @Input() set ViewOnly(value: boolean | undefined) {
        if (!!value) {
            this._ViewOnly = value;
        }
    }

    _ViewOnly: boolean = false;

    schTypeOptions: IScheduleType[] = [{ schType_Id: 1, schType_Name: "DCI" }, { schType_Id: 2, schType_Name: "Ext DCI" }, { schType_Id: 3, schType_Name: "Std DCI" }, { schType_Id: 4, schType_Name: "Vendor DCI" }];
    revCategoryList: IRevisionCategory[] = [{ revCategoryId: 1, revCategory: 'Minor' }, { revCategoryId: 2, revCategory: 'Major' }, { revCategoryId: 3, revCategory: 'First Release' }];

    @ViewChild('dciElementDetailsForm') dciElementDetailsForm!: DynamicFormComponent;
    @ViewChild('dciNoForm') dciNoDynamicForm!: DynamicFormComponent;
    @ViewChild('dciTitleForm') dciTitleDynamicForm!: DynamicFormComponent;
    @ViewChild('dciMHdetailsForm') dciMHDetailsDynamicForm!: DynamicFormComponent;
    @ViewChild('dciApprovalBy') dciApprovalByDynamicForm!: DynamicFormComponent;
    @ViewChild('dciDocsetAndStages') dciDocsetAndStagesForm!: DynamicFormComponent;
    @ViewChild('dciRevision') dciRevisionForm!: DynamicFormComponent;

    public isCanApprove: boolean = false;
    public JOBCode!: string;
    public wbsList: any = [];
    public dvcodeList: any = [];
    public panelOpenState = true;
    public enableFullscreen = false;
    public GridAenableFullscreen = false;
    public GridA1enableFullscreen = false;
    public GridBenableFullscreen = false;
    public GridB1enableFullscreen = false;
    public GridB2enableFullscreen = false;
    public skip = 0;
    public GridAskip = 0;
    public GridA1skip = 0;
    public GridBskip = 0;
    public GridB1skip = 0;
    public GridB2skip = 0;
    public PageSize = 15;
    public GridAPageSize = 15;
    public GridA1PageSize = 15;
    public GridBPageSize = 15;
    public GridB1PageSize = 15;
    public GridB2PageSize = 15;
    public EnableFilter = false;
    public GridAEnableFilter = false;
    public GridA1EnableFilter = false;
    public GridBEnableFilter = false;
    public GridB1EnableFilter = false;
    public GridB2EnableFilter = false;

    public documentRevisionSummaryDetails!: any[];
    public documentRevisionDetailedDetails: any;
    public projectName!: string;
    public membersList: ProjectMemberModel[] = [];
    public viewTransmittalData!: TransmittalTemplateComponent | null;
    projectStaticElements: IProjectElementsOutput[] = [];
    SetDCIMaxProgressLevel: IProjectElementsOutput;

    constructor(private _projService: ProjectInfoService,
        private _projectService: ProjectMasterService,
        private _scheduleDocService: ScheduleDocumentService,
        private _notificationService: NotificationService,
        private _commonService: CommonService,
        private _formBuilder: FormBuilder,
        private _scheDefService: ScheduleDefinitionService,
        public _datepipe: DatePipe, public dialog: MatDialog,
        private _transmittalService: TransmittalMsgService,
        private loaderService: LoaderService,
        private transmittalService: TransmittalService) {

    }
    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    ngOnInit(): void {
        this.projectId = this._commonService.getProjectId();
        this.memberId = this._commonService.getLoggedInUserId();
        this.groupId = this._commonService.getLoggedInUserGroupId();
        this.enableMemberRoleFeatures();
        this.getProjectName();
        this.getProjectMembers();
        this.getProjectStaticElements();
    }

    getProjectName() {
        let x: ProjectViewModel = this._commonService.getCurrentProjectDetails();
        this.projectName = x.projectCode + ' - ' + x.projectDescription;
    }

    getProjectMembers() {
        this.subscriptions.push(this.transmittalService.getProjectMembers().subscribe((res: ProjectMemberModel[]) => {
            this.membersList = res;
        }));
    }

    enableMemberRoleFeatures() {
        this.subscriptions.push(this._commonService.getProjectMemberFeatures(this.projectId, this.memberId, this.groupId).subscribe((res: any[]) => {
            this.isShowStartWF = res.some(data => data.feature_Desc == 'Start Workflow');
            this.isShowWFHistory = res.some(data => data.feature_Desc == 'Workflow History');
            this.isShowEdit = res.some(data => data.feature_Desc == 'Edit');
            this.isShowSuperEdit = res.some(data => data.feature_Desc == 'Super Edit');
            this.isShowSupersede = res.some(data => data.feature_Desc == 'Supersede');
            this.isShowApprove = res.some(data => data.feature_Desc == 'Approve');
        }));
    }

    async getProjectStaticElements() {
        await this._projService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.ScheduleDocument, IsQueryForStaticElement: true }).toPromise().then(
            (res: IProjectElementsOutput[]) => {
                if (res.length > 0) {
                    this.projectStaticElements = res;
                    let SetDCIMaxProgressLevel: IProjectElementsOutput = this.projectStaticElements.filter(x => x.elementDescription == "Set DCI Max Progress Level")[0];
                    if (!!SetDCIMaxProgressLevel)
                        if (SetDCIMaxProgressLevel.isVisible)
                            this.SetDCIMaxProgressLevel = SetDCIMaxProgressLevel;
                }
            }, err => {
                this._notificationService.showToast("failed to get static element details", "Warning");
            });
    }

    fetchDciViewDocDetails() {
        this.subscriptions.push(this._scheduleDocService.GetDCIDocumentViewDetails({
            project_Id: this._commonService.getProjectId(), group_Id: this._commonService.getLoggedInUserGroupId(),
            doc_Id: this.schDoc.doc_Id, revision_No: this.schDoc.revision_No
        }).subscribe((x: any) => {
            this._dciViewModel = x;

            this.documentRevisionSummaryDetails = x.documentRevisionDetailsOutputModel.documentRevisionSummaryDetails.map((obj: { doc_Id: any; revSequence: any; }) => ({ ...obj, documentCCNDetails: x.documentCCNDetailsOutputModel.filter((k: { doc_Id: any; rev_Sno: any; }) => k.doc_Id === obj.doc_Id && k.rev_Sno === obj.revSequence) }));

            const map2 = x.documentChecklistDetailsOutputModel.documentChecklistSummaryDetails.map((obj: { doc_Id: any; doc_Rev_No: any; task_Sl_No: any; cL_Id: any; cL_Rev_No: any; }) => ({ ...obj, objDocumentChecklistDetailedDetails: x.documentChecklistDetailsOutputModel.documentChecklistDetailedDetails.filter((k: { doc_Id: any; doc_Rev_No: any; task_Sl_No: any; cL_Id: any; cL_Rev_No: any; }) => k.doc_Id == obj.doc_Id && k.doc_Rev_No == obj.doc_Rev_No && k.task_Sl_No == obj.task_Sl_No && k.cL_Id == obj.cL_Id && k.cL_Rev_No == obj.cL_Rev_No) }))

            this.documentRevisionDetailedDetails = x.documentRevisionDetailsOutputModel.documentRevisionDetailedDetails.map((obj: { doc_Id: any; revisionNo: any; wfTaskSlno: any; }) => ({ ...obj, objDocumentChecklistSummaryDetails: map2.filter((k: { doc_Id: any; doc_Rev_No: any; task_Sl_No: any; }) => k.doc_Id == obj.doc_Id && k.doc_Rev_No == obj.revisionNo && k.task_Sl_No == obj.wfTaskSlno) }))

            this.getWBSAndDeliverableCodes();
            this.getElementDetailsForm();
            this.getDocumentNoInformationForm();
            this.getDocumentTitleForm();
            this.getApprovedByAndWorkflowForm();
            this.getDocSetAndStagesForm();
            this.getDciRevisionForm();
            this.isCanApprove = this._dciViewModel.approved_Tag;
        }))
    }

    getWBSAndDeliverableCodes() {
        if (!!this._dciViewModel.wbS_Code) {
            this.subscriptions.push(this._projectService.getProjects(this.projectId, this.memberId).subscribe((data: IProjectMasterViewModel[]) => {
                this.JOBCode = data[0].job_Code;
                this.subscriptions.push(this._scheduleDocService.GetWBSCodes({ job_Code: this.JOBCode }).subscribe((res: any) => {
                    this.wbsList = res;
                    this.subscriptions.push(this._scheduleDocService.GetDeliverableCodes({ job_Code: this.JOBCode, wBS_Code: this._dciViewModel.wbS_Code }).subscribe((res: any) => {
                        this.dvcodeList = res;
                        this.getDocumentMHDetailsForm();
                    }));
                }));
            }));
        } else {
            this.getDocumentMHDetailsForm();
        }
    }

    getElementDetailsForm() {
        let elementsConfig: FieldConfig[] = [];
        elementsConfig = this._dciViewModel.dciScheduleElementDetails.map(x => {
            let field: FieldConfig = { type: "label", label: x.dE_Description, de_id: x.dE_Id, value: new BehaviorSubject(x.deD_Short_Description + "-" + x.deD_Description) }
            return field;
        })
        this.dciElementDetailsForm.fields = [];
        this.dciElementDetailsForm.fields = elementsConfig;
        this.dciElementDetailsForm.createControl();
    }

    getDocumentNoInformationForm() {
        let documentNoConfig: FieldConfig[] = [];
        documentNoConfig.push(
            { type: "label", label: "Doc Serial No", value: new BehaviorSubject(this._dciViewModel.doc_No) },
        );
        this.dciNoDynamicForm.fields = [];
        this.dciNoDynamicForm.fields = documentNoConfig;
        this.dciNoDynamicForm.createControl();

    }
    onClick_WorkflowHistory() {

        let dialogRef = this.dialog.open(ScheduleWorkflowhistoryComponent, {
            panelClass: 'mat-dialog-content',
            data: this._schDoc,
            maxHeight: '100%'
        });

        this.subscriptions.push(dialogRef.afterClosed().subscribe((data: any) => { }));
    }

    getDocumentTitleForm() {
        let documentTitleConfig: FieldConfig[] = [];
        documentTitleConfig.push(
            { type: "label", label: "Title", value: new BehaviorSubject(this._dciViewModel.doc_Title) }
        );
        this.dciTitleDynamicForm.fields = [];
        this.dciTitleDynamicForm.fields = documentTitleConfig;
        this.dciTitleDynamicForm.createControl();
    }

    getDocumentMHDetailsForm() {
        let documentMHDetailsConfig: FieldConfig[] = [];
        documentMHDetailsConfig.push(
            { type: "label", label: "Engg Man Hours", value: new BehaviorSubject(this._dciViewModel.e_Man_Hours) },
            { type: "label", label: "Drafting Man Hours", value: new BehaviorSubject(this._dciViewModel.d_Man_Hours) },
            { type: "label", label: "Weightage", value: new BehaviorSubject(this._dciViewModel.weightage) },
            /*Input Required is removed temporarily since it has has been disabled in UI also
            { type: "label", label: "Input Required", value: new BehaviorSubject(this._dciViewModel.is_Input_Required ? "Required" : "Not Required") },*/
            { type: "label", label: "Schedule Type", value: new BehaviorSubject(this.schTypeOptions.filter(x => x.schType_Id == this._dciViewModel.schedule_Type)[0].schType_Name) },
            { type: "label", label: "WBS Code", value: new BehaviorSubject(this.wbsList.length > 0 ? this.wbsList.filter((x: { pbS_CODE: string; }) => x.pbS_CODE == this._dciViewModel.wbS_Code)[0].wbS_Description : '') },
            { type: "label", label: "Deliverable Code", value: new BehaviorSubject(this.dvcodeList.length > 0 ? this.dvcodeList.filter((x: { deliverable_Code: number; }) => x.deliverable_Code == this._dciViewModel.deliverable_Code)[0].topsheet_Desc : '') }
        );
        this.dciMHDetailsDynamicForm.fields = [];
        this.dciMHDetailsDynamicForm.fields = documentMHDetailsConfig;
        this.dciMHDetailsDynamicForm.createControl();
    }

    getApprovedByAndWorkflowForm() {
        let documentApprovedByWorkflowConfig: FieldConfig[] = [];
        documentApprovedByWorkflowConfig.push(
            { type: "label", label: "Approved By", value: new BehaviorSubject(this._dciViewModel.to_Group_Desc) },
            { type: "label", label: "Workflow", value: new BehaviorSubject(this._dciViewModel.workflow_Name) },
            { type: "label", label: "Document Set", value: new BehaviorSubject(this._dciViewModel.doc_Set_Name) });

        if (!!this.SetDCIMaxProgressLevel)
            documentApprovedByWorkflowConfig.push(
                { type: "label", label: "Max Progress Level", value: new BehaviorSubject(this._dciViewModel.max_ProgressLevel) });

        this.dciApprovalByDynamicForm.fields = [];
        this.dciApprovalByDynamicForm.fields = documentApprovedByWorkflowConfig;
        this.dciApprovalByDynamicForm.createControl();
    }

    getDocSetAndStagesForm() {
        let dciDocsetAndStages: FieldConfig[] = [];

        this._dciViewModel.dciScheduleStageDetails.forEach(y => {
            dciDocsetAndStages.push({ type: "label", label: y.stage_Desc + "(" + y.stage_Short_Desc + ")", value: new BehaviorSubject(this._datepipe.transform(y.scheduled_On, "dd-MMM-yyyy")) });
        })

        this.dciDocsetAndStagesForm.fields = [];
        this.dciDocsetAndStagesForm.fields = dciDocsetAndStages;
        this.dciDocsetAndStagesForm.createControl();
    }

    getDciRevisionForm() {
        let dciRevisionConfig: FieldConfig[] = [];
        dciRevisionConfig.push(
            { type: "label", label: "Revision", value: new BehaviorSubject(this._dciViewModel.revision_No) },
            { type: "label", label: "Released For", value: new BehaviorSubject(this._dciViewModel.doc_Status) },
            { type: "label", label: "Revision Category", value: new BehaviorSubject(this.revCategoryList.filter(x => x.revCategoryId == this._dciViewModel.revision_Category)[0].revCategory) },
            { type: "label", label: "Authorised By", value: new BehaviorSubject(this._dciViewModel.authorized_By) },
            { type: "label", label: "Print Size", value: new BehaviorSubject(this._dciViewModel.print_Size) },
            { type: "label", label: "No Of Sheets", value: new BehaviorSubject(this._dciViewModel.noOfSheets) },
            { type: "label", label: "QR Code Tag", value: new BehaviorSubject(this._dciViewModel.qrCodeStatus ? "Yes" : "No") },
            { type: "label", label: "Document Properties(Opt)", value: new BehaviorSubject(this._dciViewModel.is_Confidential ? "Confidential" : "Non-Confidential") },
            { type: "label", label: "Reference", value: new BehaviorSubject(this._dciViewModel.reference) },
            { type: "label", label: "Comments", value: new BehaviorSubject(this._dciViewModel.comments) }
        );
        this.dciRevisionForm.fields = [];
        this.dciRevisionForm.fields = dciRevisionConfig;
        this.dciRevisionForm.createControl();

    }

    /**
     * Approve or Reject DCI Document
     * @param isApproved 
     */
    approveDciDocuments(isApproved: boolean) {
        let dciDocApproveDetails: IScheduleDocApprovalDocId[] = [];
        dciDocApproveDetails.push({ doc_Id: this.schDoc.doc_Id, revision_No: this.schDoc.revision_No });
        let inputModel: IScheduleDocApprovalDetails = {
            DocSchApproveDetails: dciDocApproveDetails,
            approved_Tag: isApproved,
            userId: this.memberId
        };

        this.subscriptions.push(this._scheduleDocService.InsertUpdateScheduleApprovalDetails(inputModel).subscribe((res: StandardOutputModel) => {
            if (res.successCode == 200) {
                this._notificationService.showToast(res.successMessage, "Success");
            }
            else if (res.successCode == 205) {
                this._notificationService.showToast(res.successMessage, "Warning");
            }
            this.fetchDciViewDocDetails();
        }));
    }

    public onClick_WorkflowSupersede() {
        this._notificationService.showPopup('Are you sure to supersede the selected Document', 'Confirm').then(data => {
            if (data == 'yes') {
                let dialogRef = this.dialog.open(DciSupersedeComponent, {
                    panelClass: 'mat-dialog-primary',
                    data: this.schDoc,
                    autoFocus: false
                });
            }
        });
    }

    /**
         * Full screen
         */
    toggleFullscreen(element: any) {
        if (element == 'GridA')
            this.GridAenableFullscreen = !this.GridAenableFullscreen;
        else if (element == 'GridA1')
            this.GridA1enableFullscreen = !this.GridA1enableFullscreen;
        else if (element == 'GridB')
            this.GridBenableFullscreen = !this.GridBenableFullscreen;
        else if (element == 'GridB1')
            this.GridB1enableFullscreen = !this.GridB1enableFullscreen;
        else if (element == 'GridB2')
            this.GridB2enableFullscreen = !this.GridB2enableFullscreen;
        else
            this.enableFullscreen = !this.enableFullscreen;
    }

    public expandGridBDetails({ dataItem }: RowArgs): boolean {
        return dataItem.isCheckListAvaliable;
    }

    public expandGridADetails({ dataItem }: RowArgs): boolean {
        return dataItem.isCCNAvaliable;
    }

    public expandGridB1Details({ dataItem }: RowArgs): boolean {
        return true;
    }

    public viewAttachmentClick(dataItem: any) {
        this.dialog.open(FileListComponent, {
            panelClass: ['mat-dialog-secondary', 'w80'],
            data: { projectId: this.projectId, docId: dataItem.doc_Id, revisionNo: dataItem.revisionNo, libraryName: [FileUploadLibrary.WorkflowDocument, FileUploadLibrary.SignedDocuments], createdBy: this.memberId, isDeleteEnable: false, documentNo: null },
        });
    }

    public viewstepAttachmentClick(dataItem: any) {
        if (dataItem.integrationType == "DTN Preparation") {
            this.dialog.open(FileListComponent, {
                panelClass: ['mat-dialog-secondary', 'w80'],
                data: { projectId: this.projectId, docId: dataItem.doc_Id, revisionNo: dataItem.revisionNo, libraryName: FileUploadLibrary.SignedDocuments, createdBy: this.memberId, isDeleteEnable: false, documentNo: null },
            });
        }
        else {
            this.dialog.open(FileListComponent, {
                panelClass: ['mat-dialog-secondary', 'w80'],
                data: { projectId: this.projectId, docId: dataItem.doc_Id, revisionNo: dataItem.revisionNo, libraryName: FileUploadLibrary.WorkflowDocument, createdBy: this.memberId, isDeleteEnable: false, documentNo: null, task_SNo: dataItem.wfTaskSlno },
            });
        }
    }

    pushTransmittalTemplateModel(data: ITransmittalDetailsModel) {
        this.viewTransmittalData = null;
        let groupDetails: Observable<any> = this._transmittalService.GetTransmittalGroupMemberDetails(data.message_Id);
        let docDetails: Observable<any> = this._transmittalService.GetTransmittalDocumentDetails(data.message_Id);
        let receiverDetails: Observable<any> = this._transmittalService.GetTransmittalReceiverDetails(data.message_Id);
        this.subscriptions.push(forkJoin(groupDetails, docDetails, receiverDetails).subscribe((res: any[]) => {
            let receiverDetails: ITransmittalMsgReceiverInput = res[2];
            let docDetails: ITransmittalDocumentInput = res[1];
            let transDocDetails: ITransmittalDocumentDetails[] = [];
            if (!!docDetails && !!docDetails.transmittalDocumentDetails) {
                transDocDetails = docDetails.transmittalDocumentDetails;
            }
            let to = receiverDetails.transmittalToDetails[0].member_Id;
            let toWithAddress;
            if (to) {
                let toMember = this.membersList.filter(x => x.memberId == to)
                if (toMember[0].address) {
                    toWithAddress = toMember[0].memberName + '<br>' + toMember[0].address;
                }
                else {
                    toWithAddress = toMember[0].memberName
                }
            }
            else {
                toWithAddress = receiverDetails.transmittalToDetails.map(x => x.member_Name).join(',')
            }
            let transmittalTemplate: TransmittalTemplateComponent = {
                templateName: 'common',
                projName: this.projectName,
                edrcRef: data.message_Number,
                cusRef: '',
                docDetails: transDocDetails,
                distributionDetails: res[0],
                subject: data.message_Subject,
                attention: receiverDetails.transmittalToDetails.map(x => x.member_Name).join(','),
                to: toWithAddress,
                date: formatDate(data.created_On, 'dd-MMM-yyyy', 'en-US'),
                message_No: data.message_Number,
                message_id: data.message_Id,
                cc: receiverDetails.transmittalCcDetails.map(x => x.member_Name).join(','),
                From: receiverDetails.transmittalFromDetails.map(x => x.member_Name).join(','),
                message_Note: data.message_Note
            }
            this.viewTransmittalData = transmittalTemplate;

            setTimeout(() => {
                this.loaderService.isLoading.next(true);
                this.exportToWord(data);
                this.loaderService.isLoading.next(false);
            }, 1000);
        }))
    }

    exportToWord(data: ITransmittalDetailsModel) {
        //To check and remove "Signed Copies" column from Work document
        let rootElement: HTMLElement = document.getElementById('TransmittalComponent')?.cloneNode(true) as HTMLCanvasElement;
        let documentGrid: HTMLElement = rootElement.children[0].children["documentGrid"];

        if (documentGrid) {
            let tHead: HTMLCollection = documentGrid.children[0].children[0].children;

            if (tHead && tHead.length > 1) {
                tHead[1].remove();
            }
            for (let i = 0; i < documentGrid.children[1].children.length; i++) {
                let tBody: HTMLCollection = documentGrid.children[1].children[i].children;
                if (tBody && tBody.length > 1) {
                    tBody[1].remove();
                }
            }
        }

        let docName: string = data.message_Number;
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><style>body {margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; font-size:11px;}</style><title>Export Word Document</title></head><br><body>";
        var footer = "</body></html>";
        var html = header + rootElement.innerHTML + footer;

        var blob = new Blob(['\ufeff', html], {
            type: 'application/msword'
        });

        // Specify link url
        var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);

        // Specify file name
        let filename = docName + '.doc';

        // Create download link element
        var downloadLink = document.createElement("a");

        document.body.appendChild(downloadLink);

        if (blob) {
            saveAs(blob, filename);
            // return;
        }
        else {
            // Create a link to the file
            downloadLink.href = url;

            // Setting the file name
            downloadLink.download = filename;

            //triggering the function
            downloadLink.click();
        }

        document.body.removeChild(downloadLink);
    }

    public downloadTransmittalClick(data: any) {
        if (!!data.transmittalNo) {
            this.subscriptions.push(this._transmittalService.GetTransmittalList({ project_id: this.projectId, message_Id: data.message_Id }).subscribe((res: ITransmittalDetailsModel[]) => {
                if (res && res.length > 0) {
                    this.pushTransmittalTemplateModel(res[0]);
                }
            }));
        }
    }
}